import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
  TextField,
} from "@mui/material";
import { Form, useLoaderData, useNavigate } from "react-router-dom";
import { Result } from "../../types/Result";
import ChecklistIcon from "@mui/icons-material/Checklist";
import MessageIcon from "@mui/icons-material/Message";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import { User } from "./type";
import ProfessionChangeSection from "./ProfessionChangeSection";

export default function UserForm() {
  const data = useLoaderData() as Result<User>;
  const navigate = useNavigate();
  return (
    <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <Box>
        <Form method="post">
          <input type="hidden" name="action" value="save" id="actionField" />
          <TextField
            placeholder="Id"
            type="text"
            name="id"
            value={data.data?.id}
            fullWidth
            margin="dense"
            label="Id"
            disabled
          />
          <TextField
            placeholder="Kullanıcı Adı"
            type="text"
            name="userName"
            defaultValue={data.data?.userName}
            fullWidth
            margin="dense"
            label="Kullanıcı Adı"
            required
            disabled
          />
          <TextField
            placeholder="Ad Soyad"
            type="text"
            name="fullName"
            defaultValue={data.data?.fullName}
            fullWidth
            margin="dense"
            label="Ad Soyad"
            required
          />
          <TextField
            placeholder="Email"
            type="text"
            name="email"
            defaultValue={data.data?.email}
            fullWidth
            margin="dense"
            label="Email"
            required
            disabled
          />
          <FormControlLabel
            name="emailConfirmed"
            control={<Checkbox defaultChecked={data.data?.emailConfirmed} />}
            label="Email Onaylandı"
          />
          <TextField
            placeholder="Tc"
            type="text"
            name="tcNumber"
            defaultValue={data.data?.tcNumber}
            fullWidth
            margin="dense"
            label="Tc"
          />
          <TextField
            placeholder="Telefon"
            type="text"
            name="phoneNumber"
            defaultValue={data.data?.phoneNumber}
            fullWidth
            margin="dense"
            label="Telefon"
          />
          <TextField
            placeholder="Mezuniyet Tarihi"
            type="date"
            name="graduationDate"
            defaultValue={data.data?.graduationDate}
            fullWidth
            margin="dense"
            label="Mezuniyet Tarihi"
          />
          <TextField
            placeholder="Kilit Bitiş Tarihi"
            type="string"
            name="lockoutEnd"
            defaultValue={data.data?.lockoutEnd ?? ""}
            fullWidth
            margin="dense"
            label="Kilit Bitiş Tarihi"
            required
            disabled
          />
          <FormControlLabel
            name="phoneNumberConfirmed"
            control={
              <Checkbox defaultChecked={data.data?.phoneNumberConfirmed} />
            }
            label="Telefon Onaylandı"
          />
          <FormControlLabel
            name="isGraduationVerified"
            control={
              <Checkbox defaultChecked={data.data?.isGraduationVerified} />
            }
            label="Mezuniyet Onay"
          />
          <TextField
            placeholder="Tekrarlı Katılım Sayısı"
            type="number"
            name="totalParticipation"
            defaultValue={data.data?.totalParticipation}
            fullWidth
            margin="dense"
            label="Tekrarlı Katılım Sayısı"
            required
          />
          <TextField
            placeholder="Başarısız Giriş Sayısı"
            type="number"
            name="accessFailedCount"
            defaultValue={data.data?.accessFailedCount}
            fullWidth
            margin="dense"
            label="Başarısız Giriş Sayısı"
            required
            disabled
          />
          <Button
            fullWidth
            type="submit"
            variant="contained"
            onClick={() => {
              const actionField = document.getElementById(
                "actionField",
              ) as HTMLInputElement;
              if (actionField) actionField.value = "save";
            }}
          >
            Kaydet
          </Button>
          <Button
            fullWidth
            type="submit"
            variant="contained"
            color="error"
            sx={{ mt: 2 }}
            onClick={() => {
              const actionField = document.getElementById(
                "actionField",
              ) as HTMLInputElement;
              if (actionField) actionField.value = "lock";
            }}
          >
            Kilitle
          </Button>
          <Button
            fullWidth
            type="submit"
            variant="contained"
            sx={{ mt: 2 }}
            color="success"
            onClick={() => {
              const actionField = document.getElementById(
                "actionField",
              ) as HTMLInputElement;
              if (actionField) actionField.value = "unlock";
            }}
          >
            Kiliti Kaldır
          </Button>
          <Button
            fullWidth
            type="submit"
            variant="contained"
            sx={{ mt: 2 }}
            color="error"
            onClick={() => {
              const actionField = document.getElementById(
                "actionField",
              ) as HTMLInputElement;
              if (actionField) actionField.value = "remove-all-messages";
            }}
          >
            Tüm mesajlarını sil
          </Button>
        </Form>
        {data.data?.id && (
          <ProfessionChangeSection
            userId={data.data.id}
            professionCode={data.data.professionCode}
          />
        )}
      </Box>
      <SpeedDial
        ariaLabel="SpeedDial basic example"
        sx={{ position: "absolute", bottom: 16, right: 16 }}
        icon={<SpeedDialIcon />}
      >
        <SpeedDialAction
          icon={<ChecklistIcon />}
          tooltipTitle={"Tercihler"}
          onClick={() => navigate("preferences")}
        />
        <SpeedDialAction
          icon={<MessageIcon />}
          tooltipTitle={"Mesajlar"}
          onClick={() => navigate("/systemChats/" + data.data?.id)}
        />
        <SpeedDialAction
          icon={<ForumOutlinedIcon />}
          tooltipTitle={"Yazışmalar"}
          onClick={() => navigate("chats")}
        />
      </SpeedDial>
    </Box>
  );
}
